import React, { useEffect, useState } from "react";
import { Container } from "reactstrap";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import PointsSummary from "./components/PointsSummary";
import PointsDetail from "./components/PointsDetail";
import TablePointsExpiration from "./components/TablePointsExpiration";
import Peer2PeerHistory from "./components/Peer2PeerHistory";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { getParticipantMypointsAction } from '@/redux/actions/userActions';
import { getUserEventHistory } from "@/services/program/getUserEvents";

const MyPoints = ({ dispatch, auth, program, myPoints, pointBalance }) => {
  const { t } = useTranslation();
  const [eventHistory, setEventHistory] = useState([]);

  useEffect(() => {
    if (auth?.id && program?.id) {
      dispatch(getParticipantMypointsAction(program.organization_id, program.id, auth.id));
    }

    if (auth?.id && program?.id && program?.organization_id) {
      getUserEventHistory(program.organization_id, program.id, auth.id, 0, 99999999)
        .then((res) => setEventHistory(res.results ?? []))
        .catch(() => setEventHistory([]));
    }
  }, [auth?.id, dispatch, program?.id, program?.organization_id]);

  if (!myPoints || !pointBalance) return <div className="mp-loading">{t('loading')}</div>;

  return (
    <div className="mp-page">

      <div className="mp-page__header">
        <Container>
          <div className="mp-page__header-inner">
            <div>
              <h1 className="mp-page__title">{t('my_points')}</h1>
              <p className="mp-page__desc">{t('points_summary')}</p>
            </div>
          </div>
        </Container>
      </div>

      <Container className="mp-page__body">
        <ClearPageLayout>
          <PointsSummary eventHistory={eventHistory} />

          {myPoints.expiration && (
            <div className="mp-section">
              <TablePointsExpiration />
            </div>
          )}

          {program.uses_peer2peer > 0 && (
            <div className="mp-section">
              <Peer2PeerHistory />
            </div>
          )}

          <div className="mp-section">
            <PointsDetail eventHistory={eventHistory} />
          </div>
        </ClearPageLayout>
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  program:      state.program,
  auth:         state.auth,
  myPoints:     state.participant.myPoints,
  pointBalance: state.pointBalance,
});

export default connect(mapStateToProps)(MyPoints);
